import React from 'react';
import { Checkbox } from 'antd';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  description: string;
}

export default function SensitiveDataConsent({ checked, onChange, description }: Props) {
  return <div style={{ margin: '0 0 12px', padding: '10px 12px', background: '#fff7f2', border: '1px solid #ffd8c2', fontSize: 12, lineHeight: 1.6 }}>
    <Checkbox checked={checked} onChange={e => onChange(e.target.checked)}>
      我已阅读并同意<a href="/policy" target="_blank" rel="noreferrer" onClick={event => event.stopPropagation()}>《AI语音服务隐私政策》</a>，并同意{description}；如上传内容包含他人声音的，我确认已取得相关人员的授权同意。
    </Checkbox>
  </div>;
}
